$(document).ready(function () {
  $(".show-more").on("click", function () {
    $(".read-more-wrapper").show();
    $(this).hide();
    // $(this).text() === "Show more"
    //   ? $(this).text("Show less")
    //   : $(this).text("Show more");
  });
});
